import { MediaQuery } from "@grandvisionhq/common";
const supportedBreakpoints = [
  MediaQuery.BreakpointName.PHONE,
  MediaQuery.BreakpointName.TABLET_PORTRAIT,
  MediaQuery.BreakpointName.TABLET_LANDSCAPE,
  MediaQuery.BreakpointName.DESKTOP
];
const isComponentVisible = (breakpoint, visibility) => !visibility || !supportedBreakpoints.includes(breakpoint) || visibility.includes(breakpoint);
function useBreakpointVisibility({ component, page }) {
  const breakpoint = MediaQuery.useBreakpoint();
  const preview = page?.isPreview();
  const { visibility } = component?.getModels();
  return preview || isComponentVisible(breakpoint, visibility);
}
export {
  useBreakpointVisibility
};
//# sourceMappingURL=use-breakpoint-visibility.js.map
